import { SVGS } from '../../assets';
import { PaymentStatusEnum } from '../../constants';

export const getPaymentStatusIcon = (status: string) => {
  if (status === PaymentStatusEnum.CONFIRMED) {
    return SVGS.PaymentConfirmedIcon;
  }
  return SVGS.PaymentPaidIcon;
};
